export enum IRoleEnum {
  SUPER_ADMIN = "admin",
  ASSISTANT = "assistant",
  Teacher = "teacher",
  Student = "student",
  UNKNOWN = "unknown",
}

export enum IFileSizeUnitEnum {
  BYTES = "Bytes",
  KB = "Kb",
  MB = "Mb",
  GB = "Gb",
  TB = "Tb",
  // "PB",
  // "EB",
  // "ZB",
  // "YB",
}

export enum IParticipantBadgeEnum {
  StudentBadge = "student_badge",
  TeacherBadge = "teacher_badge",
  AssistantBadge = "assistant_badge",
  SuperAdminBadge = "superAdmin_badge",
  UnknownBadge = "unknown-badge",
}

export enum IQuestionTypesEnum {
  MultipleChoicesQuestion = "multipleChoice_question",
  TrueOrFalseQuestion = "trueOrFalseChoice_question",
  AllCourses = "allCourses",
  MidtermExam = "midtermExam",
}
